import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

import { useTeam } from '@/react-query/team'
import { useRemoveTeamMember } from '@/react-query/team-members'

export const RemoveFromTeamModal = ({
  isOpen,
  onClose,
  teamMemberEmail,
  teamMemberName,
}: {
  isOpen: boolean
  onClose: () => void
  teamMemberEmail: string
  teamMemberName: string
}) => {
  const removeTeamMember = useRemoveTeamMember()
  const team = useTeam().data

  const handleRemoveFromTeam = async () => {
    try {
      await removeTeamMember.mutateAsync(teamMemberEmail)
      onClose()
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Leave team</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Are you sure you want to remove {teamMemberName} ({teamMemberEmail})
            from the team <b>{team?.name}</b>?
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            variant={'brand-solid-red'}
            onClick={handleRemoveFromTeam}
            isLoading={removeTeamMember.isPending}
          >
            Remove from team
          </Button>
          <Button variant={'brand-solid-white'} onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
